// extracted by mini-css-extract-plugin
export default {"image":"I2-z","loaded":"J2-z"};